import React from "react";
import styled from "styled-components";
import FadeAmination from "./FadeAnimation";
import LInsvall_1 from "../images/food.webp";
import LInsvall_2 from "../images/vacan1.webp";
import LInsvall_3 from "../images/transpic2.webp";
import LInsvall_4 from "../images/ocf.webp";
/* import LInsvall_5 from "../images/LifeStyle1.jpg"; */

function LatestInsightsViewAll() {
  return (
    <LatestInsightVallcon>
      <h2>Latest Insights All</h2>
      <FadeAmination />
      <div className="LatestInsightVallGrid">
        {LatestInsightsData.map((LatestInsight) => (
          <div className="gallery-container">
            {/*this is for one object: start here */}
            <div className="gallery-iitem">
              <div className="image">
                <img
                  src={LatestInsight.img}
                  alt={LatestInsight.LatestInsight}
                />
                <div className="text">{LatestInsight.Title}</div>
                <br />
                <div>{LatestInsight.desc}</div>
              </div>
            </div>
            {/*this is for one object: end here */}
          </div>
        ))}
      </div>
    </LatestInsightVallcon>
  );
}

export default LatestInsightsViewAll;

export const LatestInsightsData = [
  {
    id: "Linst1",
    Title: "Resilience",
    /*   price: 45, */
    desc: "The role of refrigerated warehousing in keeping cold chains stable",
    img: LInsvall_1,
    LearnMore: `/ProjectCargoCon`,
  },

  {
    id: "Linst2",
    Title: "Resilience",
    /*   price: 45, */
    desc: "Project cargo is the transportation of any item that is too big or too heavy to fit into an ocean freight container or a truck trailer. These oversize and heavy items are often complex to transport and require an individualized plan to move domestically or internationally",
    img: LInsvall_2,
    LearnMore: `/ProjectCargoCon`,
  },

  {
    id: "Linst3",
    Title: "Resilience",
    /*   price: 45, */
    desc: "Project cargo is the transportation of any item that is too big or too heavy to fit into an ocean freight container or a truck trailer. These oversize and heavy items are often complex to transport and require an individualized plan to move domestically or internationally",
    img: LInsvall_3,
    LearnMore: `/ProjectCargoCon`,
  },

  {
    id: "svr4",
    Title: "Resilience",
    /*   price: 45, */
    desc: "Project cargo is the transportation of any item that is too big or too heavy to fit into an ocean freight container or a truck trailer. These oversize and heavy items are often complex to transport and require an individualized plan to move domestically or internationally",
    img: LInsvall_4,
    LearnMore: `/ProjectCargoCon`,
  },
];

const LatestInsightVallcon = styled.div`
  width: 75vw;
  margin-left: calc((100vw - 75vw) / 2);
  margin-right: calc((100vw - 75vw) / 2);

  .LatestInsightVallGrid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    margin-top: 10px;
  }

  .gallery-iitem {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .gallery-iitem .image {
    width: 100%;
    height: 70%;
  }
  .gallery-iitem .image img {
    width: 100%;
    height: 70%;
    object-fit: cover;
    object-position: 50% 50%;
    cursor: pointer;
    /*   transition: 0.5s ease-in-out; */
  }
`;
